/* eslint-disable */
/* Note: this code is generated by generateItemTypes.js, do not modify it */
import that from '../utilities/translationHelper'
const itemTypes = {
	"ARM-WARMER": {
		type: "ARM-WARMER",
		name: that.context.translate("Arm Warmer")
	},
	"BMX": {
		type: "BMX",
		name: that.context.translate("BMX")
	},
	"BACKPACK": {
		type: "BACKPACK",
		name: that.context.translate("Backpack")
	},
	"BAG": {
		type: "BAG",
		name: that.context.translate("Bag")
	},
	"BAR-TAPE": {
		type: "BAR-TAPE",
		name: that.context.translate("Bar Tape")
	},
	"BASE-LAYER": {
		type: "BASE-LAYER",
		name: that.context.translate("Base Layer")
	},
	"BIB-SHORT": {
		type: "BIB-SHORT",
		name: that.context.translate("Bib Short")
	},
	"BIB-TIGHT": {
		type: "BIB-TIGHT",
		name: that.context.translate("Bib Tight")
	},
	"BIDON": {
		type: "BIDON",
		name: that.context.translate("Bidon")
	},
	"BOOK": {
		type: "BOOK",
		name: that.context.translate("Book")
	},
	"BOTTLE": {
		type: "BOTTLE",
		name: that.context.translate("Bottle")
	},
	"BRA": {
		type: "BRA",
		name: that.context.translate("Bra")
	},
	"BRAKE": {
		type: "BRAKE",
		name: that.context.translate("Brake")
	},
	"CABLE": {
		type: "CABLE",
		name: that.context.translate("Cable")
	},
	"CAP": {
		type: "CAP",
		name: that.context.translate("Cap")
	},
	"CASE": {
		type: "CASE",
		name: that.context.translate("Case")
	},
	"CASSETTE": {
		type: "CASSETTE",
		name: that.context.translate("Cassette")
	},
	"CHAIN": {
		type: "CHAIN",
		name: that.context.translate("Chain")
	},
	"CHAINRING": {
		type: "CHAINRING",
		name: that.context.translate("Chainring")
	},
	"CHAINSET": {
		type: "CHAINSET",
		name: that.context.translate("Chainset")
	},
	"CLEANING": {
		type: "CLEANING",
		name: that.context.translate("Cleaning")
	},
	"COMMUTER-BIKE": {
		type: "COMMUTER-BIKE",
		name: that.context.translate("Commuter Bike")
	},
	"COMPUTER": {
		type: "COMPUTER",
		name: that.context.translate("Computer")
	},
	"CREAM": {
		type: "CREAM",
		name: that.context.translate("Cream")
	},
	"CYCLOCROSS-BIKE": {
		type: "CYCLOCROSS-BIKE",
		name: that.context.translate("Cyclocross Bike")
	},
	"DEFAULT": {
		type: "DEFAULT",
		name: that.context.translate("DEFAULT")
	},
	"DRIVETRAIN": {
		type: "DRIVETRAIN",
		name: that.context.translate("Drivetrain")
	},
	"ELECTRIC-MOUNTAIN-BIKE": {
		type: "ELECTRIC-MOUNTAIN-BIKE",
		name: that.context.translate("Electric Mountain Bike")
	},
	"ELECTRIC-ROAD-BIKE": {
		type: "ELECTRIC-ROAD-BIKE",
		name: that.context.translate("Electric Road Bike")
	},
	"EVENT": {
		type: "EVENT",
		name: that.context.translate("Event")
	},
	"EYEWEAR": {
		type: "EYEWEAR",
		name: that.context.translate("Eyewear")
	},
	"FRAME": {
		type: "FRAME",
		name: that.context.translate("Frame")
	},
	"FULL-SUSPENSION-MOUNTAIN-BIKE": {
		type: "FULL-SUSPENSION-MOUNTAIN-BIKE",
		name: that.context.translate("Full Suspension Mountain Bike")
	},
	"GPS": {
		type: "GPS",
		name: that.context.translate("GPS")
	},
	"GEARS": {
		type: "GEARS",
		name: that.context.translate("Gears")
	},
	"GILET": {
		type: "GILET",
		name: that.context.translate("Gilet")
	},
	"GLASSES": {
		type: "GLASSES",
		name: that.context.translate("Glasses")
	},
	"GLOVE": {
		type: "GLOVE",
		name: that.context.translate("Glove")
	},
	"GOGGLE": {
		type: "GOGGLE",
		name: that.context.translate("Goggle")
	},
	"HANDLEBAR": {
		type: "HANDLEBAR",
		name: that.context.translate("Handlebar")
	},
	"HARD-TAIL-MOUNTAIN-BIKE": {
		type: "HARD-TAIL-MOUNTAIN-BIKE",
		name: that.context.translate("Hard Tail Mountain Bike")
	},
	"HAT": {
		type: "HAT",
		name: that.context.translate("Hat")
	},
	"HEADBAND": {
		type: "HEADBAND",
		name: that.context.translate("Headband")
	},
	"HELMET": {
		type: "HELMET",
		name: that.context.translate("Helmet")
	},
	"HELMET-ACCESSORY": {
		type: "HELMET-ACCESSORY",
		name: that.context.translate("Helmet Accessory")
	},
	"HOODIE": {
		type: "HOODIE",
		name: that.context.translate("Hoodie")
	},
	"HYDRATION-DEVICE": {
		type: "HYDRATION-DEVICE",
		name: that.context.translate("Hydration Device")
	},
	"INNER-TUBE": {
		type: "INNER-TUBE",
		name: that.context.translate("Inner Tube")
	},
	"JACKET": {
		type: "JACKET",
		name: that.context.translate("Jacket")
	},
	"JEAN": {
		type: "JEAN",
		name: that.context.translate("Jean")
	},
	"JERSEY": {
		type: "JERSEY",
		name: that.context.translate("Jersey")
	},
	"JERSEY-AND-BIB-SHORT": {
		type: "JERSEY-AND-BIB-SHORT",
		name: that.context.translate("Jersey And Bib Short")
	},
	"JUMPER": {
		type: "JUMPER",
		name: that.context.translate("Jumper")
	},
	"KIDS-BIKE": {
		type: "KIDS-BIKE",
		name: that.context.translate("Kids Bike")
	},
	"KNEE-WARMER": {
		type: "KNEE-WARMER",
		name: that.context.translate("Knee Warmer")
	},
	"LEG-WARMER": {
		type: "LEG-WARMER",
		name: that.context.translate("Leg Warmer")
	},
	"LENS": {
		type: "LENS",
		name: that.context.translate("Lens")
	},
	"LIGHT": {
		type: "LIGHT",
		name: that.context.translate("Light")
	},
	"LONG-SLEEVE-JERSEY": {
		type: "LONG-SLEEVE-JERSEY",
		name: that.context.translate("Long Sleeve Jersey")
	},
	"MEMBERSHIP": {
		type: "MEMBERSHIP",
		name: that.context.translate("Membership")
	},
	"MOUNTAIN-BIKE": {
		type: "MOUNTAIN-BIKE",
		name: that.context.translate("Mountain Bike")
	},
	"NECK-WARMER": {
		type: "NECK-WARMER",
		name: that.context.translate("Neck warmer")
	},
	"OIL": {
		type: "OIL",
		name: that.context.translate("Oil")
	},
	"PANT": {
		type: "PANT",
		name: that.context.translate("Pant")
	},
	"PEDALS": {
		type: "PEDALS",
		name: that.context.translate("Pedals")
	},
	"PHONE-POCKET": {
		type: "PHONE-POCKET",
		name: that.context.translate("Phone pocket")
	},
	"POLO-SHIRT": {
		type: "POLO-SHIRT",
		name: that.context.translate("Polo Shirt")
	},
	"POUCH": {
		type: "POUCH",
		name: that.context.translate("Pouch")
	},
	"PUMP": {
		type: "PUMP",
		name: that.context.translate("Pump")
	},
	"PUNCTURE-REPAIR": {
		type: "PUNCTURE-REPAIR",
		name: that.context.translate("Puncture Repair")
	},
	"REFLECTIVE": {
		type: "REFLECTIVE",
		name: that.context.translate("Reflective")
	},
	"ROAD-BIKE": {
		type: "ROAD-BIKE",
		name: that.context.translate("Road Bike")
	},
	"ROAD-BIKE-DISC": {
		type: "ROAD-BIKE-DISC",
		name: that.context.translate("Road Bike Disc")
	},
	"SADDLE": {
		type: "SADDLE",
		name: that.context.translate("Saddle")
	},
	"SADDLE-BAG": {
		type: "SADDLE-BAG",
		name: that.context.translate("Saddle bag")
	},
	"SEAT-POST": {
		type: "SEAT-POST",
		name: that.context.translate("Seat Post")
	},
	"SHOE": {
		type: "SHOE",
		name: that.context.translate("Shoe")
	},
	"SHOE-COVER": {
		type: "SHOE-COVER",
		name: that.context.translate("Shoe Cover")
	},
	"SHORT": {
		type: "SHORT",
		name: that.context.translate("Short")
	},
	"SHORT-SLEEVE-JERSEY": {
		type: "SHORT-SLEEVE-JERSEY",
		name: that.context.translate("Short Sleeve Jersey")
	},
	"SINGLE-SPEED-BIKE": {
		type: "SINGLE-SPEED-BIKE",
		name: that.context.translate("Single Speed Bike")
	},
	"SKINSUIT": {
		type: "SKINSUIT",
		name: that.context.translate("Skinsuit")
	},
	"SLEEPING-BAG": {
		type: "SLEEPING-BAG",
		name: that.context.translate("Sleeping Bag")
	},
	"SOCK": {
		type: "SOCK",
		name: that.context.translate("Sock")
	},
	"SPORTS-BRA": {
		type: "SPORTS-BRA",
		name: that.context.translate("Sports Bra")
	},
	"STEERING": {
		type: "STEERING",
		name: that.context.translate("Steering")
	},
	"STEMS": {
		type: "STEMS",
		name: that.context.translate("Stems")
	},
	"SUNGLASSES": {
		type: "SUNGLASSES",
		name: that.context.translate("Sunglasses")
	},
	"SWEATPANT": {
		type: "SWEATPANT",
		name: that.context.translate("Sweatpant")
	},
	"SWEATSHIRT": {
		type: "SWEATSHIRT",
		name: that.context.translate("Sweatshirt")
	},
	"T-SHIRT": {
		type: "T-SHIRT",
		name: that.context.translate("T-Shirt")
	},
	"TANK-TOP": {
		type: "TANK-TOP",
		name: that.context.translate("Tank Top")
	},
	"THERMAL": {
		type: "THERMAL",
		name: that.context.translate("Thermal")
	},
	"THERMAL-BIB-TIGHT": {
		type: "THERMAL-BIB-TIGHT",
		name: that.context.translate("Thermal Bib Tight")
	},
	"TIGHT": {
		type: "TIGHT",
		name: that.context.translate("Tight")
	},
	"TOOLS": {
		type: "TOOLS",
		name: that.context.translate("Tools")
	},
	"TRACK-BIKE": {
		type: "TRACK-BIKE",
		name: that.context.translate("Track Bike")
	},
	"TROUSER": {
		type: "TROUSER",
		name: that.context.translate("Trouser")
	},
	"TURBO-TRAINER": {
		type: "TURBO-TRAINER",
		name: that.context.translate("Turbo Trainer")
	},
	"TYRE": {
		type: "TYRE",
		name: that.context.translate("Tyre")
	},
	"UNDERWEAR": {
		type: "UNDERWEAR",
		name: that.context.translate("Underwear")
	},
	"URBAN-BIKE": {
		type: "URBAN-BIKE",
		name: that.context.translate("Urban Bike")
	},
	"VEST": {
		type: "VEST",
		name: that.context.translate("Vest")
	},
	"WALLET": {
		type: "WALLET",
		name: that.context.translate("Wallet")
	},
	"WATCH": {
		type: "WATCH",
		name: that.context.translate("Watch")
	},
	"WATER-BOTTLE": {
		type: "WATER-BOTTLE",
		name: that.context.translate("Water Bottle")
	},
	"WATERPROOFING": {
		type: "WATERPROOFING",
		name: that.context.translate("Waterproofing")
	},
	"WHEEL": {
		type: "WHEEL",
		name: that.context.translate("Wheel")
	}
}
export default itemTypes



// WEBPACK FOOTER //
// ./src/enums/itemTypes.js